import React from "react";
import stylesSCTree from "../SCTree.module.css";

export class TreeAdvancedSearchLegenda extends React.Component {

    render() {
        return <div className={stylesSCTree['tree-item-search__legenda__text']}>
            <div className={stylesSCTree['tree-item-search__legenda__text__title']}>Istruzioni per la ricerca avanzata
            </div>
            <div className={stylesSCTree['tree-item-search__legenda__text__disclaimer']}>(Queste istruzioni valgono solo
                per campi testo e campi preriempiti, mentre sono esclusi campi ricerca per documenti contraddistinti
                dall'etichetta preceduta dal simbolo <strong>'*'</strong>. Per i documenti verranno trovate solo corrispondenze
                esatte
            </div>
            <ul className={stylesSCTree['tree-item-search__legenda__text__contents']}>
                <li><strong>+parola1 +parola2 +parola3</strong> deve contenere queste parole (<u>importante</u> spazio
                    tra
                    gli elementi con +) . Esempio: <strong>+comune +di</strong> trova tutti le voci che contengono
                    sia <strong>comune</strong> sia <strong>di</strong> anche in ordine sparso (vedi terzo risultato):
                    <i>
                        <ul>
                            <li>000 - Compartecipazione acquisto mezzo Polizia locale Val di Fassa - <strong>Comune
                                di</strong> Moena
                            </li>
                            <li>Proroga accordo temporanea messa a disposizione Pellegrin Franco a <strong>Comune
                                di</strong> Soraga
                            </li>
                            <li>102 - sostituzione <strong>comune</strong> pagamenti TIA 2018 San
                                Giovanni <strong>di</strong> Fassa
                            </li>
                        </ul>
                    </i>
                </li>
                <li><strong>-parola</strong> <u>non</u> deve contenere quella parola. Esempio: <strong>-comune</strong> troverà
                    tutte le voci che non contengono <strong>comune</strong>. <u>E' possibile combinare + e -</u>.
                    Esempio:<strong>+comune -di</strong> trova tutte le voci che contengono <strong>comune</strong> ma
                    non <strong>di</strong></li>
                <li><strong>par*, *par, *par*</strong> rispettivamente <u>inizia per</u>, <u>finisce
                    per</u>, <u>contiene</u>. <strong>Par*</strong> può appartenere a qualsiasi parola nella frase. Ad
                    esempio <strong>derog*</strong> trova anche <i>Punto 9 delibera <strong>deroga</strong> Hotel Monti
                        Pallidi</i>
                    Inoltre adesso puoi finalmente anche cercare frasi tipo: <strong>acquisto m*</strong>
                    <i>000 - Compartecipazione <strong>acquisto me</strong>zzo Polizia locale Val di Fassa - Comune di
                        Moena</i>
                    <i>percorso geologico <strong>acquisto m</strong>assi</i>
                    La ricerca deve rispettare la sequenza e non si troveranno risultati in cui un m* si trova in altre posizioni.
                </li>
                <li><strong>acquisto massi</strong> trova la frase scritta in quest'ordine come in precedenza, ma non
                    troverà titoli
                    contenenti, ad esempio <strong>acquisto massimo</strong>
                </li>
                <li><strong>acquisto mezzo && val di</strong> troverà tutti gli elementi che contengono sia <strong>acquisto
                    mezzo</strong> che <strong>val di</strong>.
                    Esempio:
                    <i>000 - Compartecipazione acquisto mezzo Polizia locale Val di Fassa - Comune di Moena</i>
                </li>
            </ul>
        </div>
    }
}